<template>
    <component
        @click="click"
        class="x-button font-opensans"
        :is="tag"
        :style="`background-color: ${bgColor}; color: ${color}; font-weight: ${fontWeight}`"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: 'XButton',

    props: {
        tag: {
            type: String,
            default: 'button'
        },

        bgColor: {
            type: String,
            default: '#000'
        },

        color: {
            type: String,
            default: '#fff'
        },

        fontWeight: {
            type: String,
            default: 'bold'
        }
    },

    methods: {
        click(e) {
            this.$emit('click', e)
        }
    }
}
</script>

<style lang="scss" scoped>
.x-button {
    // min-width: 80px;
    height: 40px;
    padding: 0 16px;
    font-size: 16px;
    border: none;
    border-radius: 4px;
    color: #fff;
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: rgba(#000, 0.7);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed !important;
    }
}
</style>